import {
  useCurrentRefinements,
  useRefinementList,
} from "react-instantsearch-hooks-web";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { BsCircle, BsRecordCircleFill } from "react-icons/bs";
import { IoMdArrowDropdown } from "react-icons/io";

function ListingTypeRefinementList({ listingType, setListingType, param }) {
  const {
    items,
    hasExhaustiveItems,
    createURL,
    refine,
    sendEvent,
    searchForItems,
    isFromSearch,
    canRefine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
  } = useRefinementList({ attribute: "listingType" });
  //console.log(items);
  const lab = items.find((el) => el?.value == "RENT");
  // console.log(param);

  const props = useCurrentRefinements();
  //console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  // console.log(itemRefs);
  const arr = itemRefs.find((c) => c.attribute === "RENT");
  //  console.log(arr);

  return (
    <>
      <DropdownMenu.Root>
        {items.length > 0 ? (
          <DropdownMenu.Trigger asChild>
            {lab && listingType === "Rent" ? (
              <button className=" flex flex-shrink-0 cursor-pointer select-none flex-row rounded border border-gray-400 bg-white px-3 py-2 text-sm text-gray-900 lg:px-5 lg:py-3">
                <>
                  <span className=" flex lg:hidden">Rent</span>
                  <span className=" hidden lg:flex">For Rent</span>

                  <IoMdArrowDropdown className=" h-5 w-5 text-gray-700" />
                </>
              </button>
            ) : (
              <button className=" flex-shrink-0 cursor-pointer select-none rounded border border-blue-600 bg-white px-5 py-2 text-sm text-blue-600">
                For Sale
              </button>
            )}
          </DropdownMenu.Trigger>
        ) : null}
        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={2}
            className=" z-20 h-auto w-auto rounded-md border border-gray-300 bg-white px-6 pb-6 pt-5 shadow-md"
          >
            <DropdownMenu.Label className=" text-sm text-gray-600">
              Market
            </DropdownMenu.Label>
            <DropdownMenu.RadioGroup
              value={listingType}
              onValueChange={(el) => {
                setListingType(el);
                if (el === "Rent") {
                  // refine([undefined]);
                  refine("RENT");
                } else {
                  refine("SALE");
                }
              }}
              className="mt-2 flex flex-col space-y-3"
            >
              {items?.map((item) => {
                //console.log(item);
                if (item.value === "RENT") {
                  return (
                    <DropdownMenu.RadioItem
                      key={item.value}
                      value="Rent"
                      className=" flex flex-row items-center space-x-2 outline-none"
                    >
                      <DropdownMenu.ItemIndicator forceMount>
                        {listingType === "Rent" ? (
                          <BsRecordCircleFill className="h-5 w-5 text-zote-primary" />
                        ) : (
                          <BsCircle className="h-5 w-5 text-gray-600" />
                        )}
                      </DropdownMenu.ItemIndicator>
                      <span className=" cursor-pointer text-base text-gray-800 hover:text-gray-900">
                        For Rent
                      </span>
                    </DropdownMenu.RadioItem>
                  );
                } else {
                  return (
                    <DropdownMenu.RadioItem
                      key={item.value}
                      value="Sale"
                      className=" flex flex-row items-center space-x-2 outline-none"
                    >
                      <DropdownMenu.ItemIndicator forceMount>
                        {listingType === "Sale" ? (
                          <BsRecordCircleFill className="h-5 w-5 text-zote-primary" />
                        ) : (
                          <BsCircle className="h-5 w-5 text-gray-600" />
                        )}
                      </DropdownMenu.ItemIndicator>
                      <span className=" cursor-pointer text-base text-gray-800 hover:text-gray-900">
                        For Sale
                      </span>
                    </DropdownMenu.RadioItem>
                  );
                }
              })}
            </DropdownMenu.RadioGroup>
            <DropdownMenu.Arrow
              className="  fill-gray-200"
              width={10}
              height={5}
            />
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </>
  );
}
export default ListingTypeRefinementList;
